import { useState } from "react";
import { axios } from "../boot";

export default function useGetGroups() {
  const [ groups, setGroups ] = useState([]);
  const getGroups = () => {
    const url = "/admins/classgroup";
    axios.get(url).then((res) => {
      
      const data = res.data.data.map((e) => ({ ...e, isAdmin: true }));
      
      setGroups(data);
    });
  };
  return [groups, getGroups];
}
